// Aritco
import { AritcoRequest } from "../shared/models";
import { ViewChild, ChangeDetectorRef } from "@angular/core";
import { ModelFactory } from "../shared/providers";
import { AritcoController } from "../shared/aritco/aritcoController";
import { AritcoStore } from "../shared/aritco/aritcoStore";
import { Observable } from "rxjs";
// End
import { Component, ViewEncapsulation, Inject } from "@angular/core";

import { Routing } from "../../shared/route/routeDecorator";
import { AppStoreSubscriptionManager, ApplicationLifeCycleService, ApiMessageProvider, AppActionCreator, RouteNames, IHttpDataInfo, BroadcastChannelService, BroadcastChannelMessageType } from "../shared/providers";
import { PageComponent } from "../shared";
import { GlobalDataStore } from "../shared/providers/globalData";
import { AccountDataStore } from "../shared/providers/accountData";
import { NotificationService, NotificationInfo, NotificationType } from "../../shared/components";
import { CacheReloadMessage } from "../shared/models";
import { PageStore } from "../shared/providers/page";

@Routing({ path: 'settings' })
@Routing({ path: '**' })
@Component({
  encapsulation: ViewEncapsulation.None,
  templateUrl: './settingsComponent.html',
  providers: [AppStoreSubscriptionManager]
})
export class SettingsComponent extends PageComponent {

  public databaseConnectionInfo: string = "";

  public showAdminSection: boolean = false;

  private enableDefaultLifeCycleUpdate = true;

  // Aritco
  public running: boolean = false;
  
  datePickerConfig = {
    firstDayOfWeek: 'su',
    monthFormat: 'MMM, YYYY',
    disableKeypress: false,
    allowMultiSelect: false,
    closeOnSelect: undefined,
    closeOnSelectDelay: 100,
    openOnFocus: true,
    openOnClick: true,
    onOpenDelay: 0,
    closeOnEnter: true,
    weekDayFormat: 'ddd',
    appendTo: document.body,
    showNearMonthDays: true,
    showWeekNumbers: true,
    enableMonthSelector: true,
    yearFormat: 'YYYY',
    showGoToCurrent: true,
    dayBtnFormat: 'DD',
    monthBtnFormat: 'MMM',
    hours12Format: 'hh',
    hours24Format: 'HH',
    meridiemFormat: 'A',
    minutesFormat: 'mm',
    minutesInterval: 1,
    secondsFormat: 'ss',
    secondsInterval: 1,
    showSeconds: false,
    showTwentyFourHours: false,
    timeSeparator: ':',
    multipleYearsNavigateBy: 10,
    showMultipleYearsNavigation: false,
    //locale: moment.locale(),
    hideInputContainer: false,
    //returnedValueType: ECalendarValue.String,
    unSelectOnClick: true,
    hideOnOutsideClick: true,
    numOfMonthRows: 3
  };
  // End

  constructor(
    // Aritco
    public modelFactory: ModelFactory,
    public aritcoController: AritcoController,
    public aritcoStore: AritcoStore,
    public cdr: ChangeDetectorRef,
    // End
    public appActionCreator: AppActionCreator,
    public appLifeCycleService: ApplicationLifeCycleService,
    public appStoreSubscriptionManager: AppStoreSubscriptionManager,
    public globalDataStore: GlobalDataStore,
    public accountStore: AccountDataStore,
    public notificationService: NotificationService,
    @Inject(ApiMessageProvider) public apiMessageProvider: ApiMessageProvider,
    public pageStore: PageStore,
    @Inject(BroadcastChannelService) public broadcastChannelService: BroadcastChannelService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageStore.updateActiveRoute(RouteNames.Settings);

    this.setInfo();

    this.apiMessageProvider.onMessages<CacheReloadMessage>(CacheReloadMessage.name, {
      next: (messages) => {
        let cacheReloadMessage = messages.first();
        if (cacheReloadMessage.success) {

          this.appLifeCycleService.cacheReloaded(() => {
            this.notificationService.notify(<NotificationInfo>{
              title: this.strings.Success,
              message: this.strings.ReloadCaches_Message,
              type: NotificationType.Success,
              selfClose: true
            });

            this.broadcastChannelService.send(BroadcastChannelMessageType.ReloadCache);
            this.setInfo();
            this.enableDefaultLifeCycleUpdate = true;
            this.unblockUI();
          });
        }
        else {
          // Handle server errors in message
          this.notificationService.notify(<NotificationInfo>{
            title: this.strings.Error,
            message: cacheReloadMessage.messages.join(". "), // TODO handle in better way
            type: NotificationType.Error,
            selfClose: true
          });

          this.enableDefaultLifeCycleUpdate = true;
          this.unblockUI();
        }
      }, listenNewEventsOnly: true
    }).unsubscribeOn(this.unsubscribeSubject);
  }

  public reloadCaches() {
    this.reload(false);
  }

  public reloadUserCaches() {
    this.reload(true);
  }

  public reload(userDataOnly: boolean) {
    this.blockUI();
    this.enableDefaultLifeCycleUpdate = false;
    this.appActionCreator.dispatchReloadCaches(userDataOnly);
  }

  setInfo() {
    let webSettings = this.globalDataStore.getGlobalData().webSettings;
    this.databaseConnectionInfo = webSettings.databaseConnectionInfo;

    let user = this.accountStore.getUser();

    // TODO authorization
    this.showAdminSection = user.systemAuthorization.canReloadCache;
  }

  ngOnDestroy() {
    this.appStoreSubscriptionManager.dispose();
    super.ngOnDestroy();
  }
  // Aritco
  public updateConfigurations() {

    if (!confirm("Are you sure you want to automatically update configurations!"))
      return;

    let aritcoRequest = this.modelFactory.createRequestOrCommand<AritcoRequest>(AritcoRequest.name);
    aritcoRequest.updateConfigurations = true;

    this.aritcoStore.get(aritcoRequest).subscribe(response => {

      if (response.success) {

        this.running = true;

        setTimeout(() => {
          this.reportProgressUpdateConfigurations()
        }, 1000);
      }

      this.notificationService.notify(<NotificationInfo>{
        title: "Aritco",
        message: response.message,
        type: NotificationType.Success,
        selfClose: true,
      });

      this.cdr.detectChanges();
      this.unblockUI();

    }).unsubscribeOn(this.unsubscribeSubject);
  }

  public reportProgressUpdateConfigurations() {

    this.aritcoStore.updateProgress().subscribe(response => {

      if (!response.done)
        setTimeout(() => {
          this.reportProgressUpdateConfigurations()
        }, 1000);
      else
        this.running = false;

      if (response.message) {

        this.notificationService.notify(<NotificationInfo>{
          title: "eSyber",
          message: response.message,
          type: NotificationType.Success,
          selfClose: true,
          identifier: "UpdateConfigurations",
          sync: true
        });
      }

      this.cdr.detectChanges();
      this.unblockUI();
    }).unsubscribeOn(this.unsubscribeSubject);
  }
  // End

  onHttpLifeCycleUpdate(http: IHttpDataInfo) {
    if (this.enableDefaultLifeCycleUpdate)
      super.onHttpLifeCycleUpdate(http);
  }
}